import {ValueObject} from '@s-ui/domain'

import {NotFoundSharedError} from '../Errors/NotFoundSharedError.js'

export class ListSharedValueObject extends ValueObject {
  #value

  constructor({value}) {
    super()
    this.#value = value
  }

  static empty() {
    return new ListSharedValueObject({value: []})
  }

  static create({value}) {
    if (!Array.isArray(value)) {
      return ListSharedValueObject.empty()
    }
    return new ListSharedValueObject({value})
  }

  static validate({value}) {
    if (!Array.isArray(value)) {
      throw new Error('Value must be an array')
    }

    if (value.length === 0) {
      throw NotFoundSharedError.create('No items found')
    }
  }

  get value() {
    return this.#value.map(item => item.value)
  }

  get isEmpty() {
    return this.#value.length === 0
  }
}
